import React, { useEffect, useState } from 'react';
import * as api from '../api';

export default function SecurityPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getSecurity()
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Loading security data...</div>;
  if (!data) return <div className="empty-state"><p>Unable to load security dashboard.</p></div>;

  return (
    <div>
      <div className="page-header">
        <h1>Security</h1>
        <p>Failed login attempts and suspicious activity</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Failed Logins (24h)</div>
          <div className="stat-value">{data.failedLogins.last24h}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Failed Logins (All Time)</div>
          <div className="stat-value">{data.failedLogins.allTime}</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
        <div className="card">
          <div className="card-header"><span className="card-title">Top Targeted Emails (24h)</span></div>
          {data.failedLogins.byEmail.length === 0 ? (
            <p style={{ color: '#888', fontSize: 14 }}>No failed attempts.</p>
          ) : (
            <table>
              <thead><tr><th>Email</th><th>Attempts</th></tr></thead>
              <tbody>
                {data.failedLogins.byEmail.map((r, i) => (
                  <tr key={i}>
                    <td>{r.email}</td>
                    <td><span className={`badge ${r.count >= 5 ? 'badge-red' : 'badge-yellow'}`}>{r.count}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="card">
          <div className="card-header"><span className="card-title">Top IPs (24h)</span></div>
          {data.failedLogins.byIp.length === 0 ? (
            <p style={{ color: '#888', fontSize: 14 }}>No failed attempts.</p>
          ) : (
            <table>
              <thead><tr><th>IP Address</th><th>Attempts</th></tr></thead>
              <tbody>
                {data.failedLogins.byIp.map((r, i) => (
                  <tr key={i}>
                    <td style={{ fontFamily: 'monospace', fontSize: 13 }}>{r.ip || 'Unknown'}</td>
                    <td><span className={`badge ${r.count >= 10 ? 'badge-red' : 'badge-yellow'}`}>{r.count}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-header"><span className="card-title">Recent Failed Login Attempts</span></div>
        <div className="table-container">
          <table>
            <thead>
              <tr><th>Email</th><th>IP</th><th>Reason</th><th>Date</th></tr>
            </thead>
            <tbody>
              {data.recentAttempts.map((a) => (
                <tr key={a.id}>
                  <td>{a.email}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 13 }}>{a.ipAddress || '—'}</td>
                  <td><span className="badge badge-red">{a.reason}</span></td>
                  <td style={{ fontSize: 13, color: '#888', whiteSpace: 'nowrap' }}>
                    {new Date(a.createdAt).toLocaleString('en-ZA')}
                  </td>
                </tr>
              ))}
              {data.recentAttempts.length === 0 && (
                <tr><td colSpan={4} style={{ textAlign: 'center', color: '#888' }}>No failed attempts recorded.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
